import React from "react";
import {
  Row,
  Column,
  FormGroup,
  Checkbox,
  TextInput,
  RadioButtonGroup,
  RadioButton,
  TextArea,
} from "carbon-components-react";
import useGet from "../../hooks/useGet";
import DynamicCheckbox from "../Checkboxes/DynamicCheckbox";
import {
  isCandidatureOptionChecked,
  updateCheckedOptions,
} from "../../services/Utils";
import { useEffect } from "react";
import GenericCombo from "../Combos/GenericCombo";

const BusinessDetailsForm = ({
  disabled,
  register,
  control,
  errors,
  candidature,
  selectedWorkAreas,
  setSelectedWorkAreas,
  selectedBusinessPhases,
  setSelectedBusinessPhases,
}) => {
  const { data: workAreas } = useGet("/lookup/work-areas");
  const { data: legalForms } = useGet("/lookup/legal-forms");
  const { data: businessManagements } = useGet("/lookup/business-managements");
  const { data: businessPhases } = useGet("/lookup/business-phases");
  const { data: ecommercePlatforms } = useGet("/lookup/e-commerce-platforms");
  const { data: orderSources } = useGet("/lookup/order-sources");

  const updateWorkAreas = (id, checked) => {
    setSelectedWorkAreas(updateCheckedOptions(selectedWorkAreas, id, checked));
  };

  const updatePhases = (id, checked) => {
    setSelectedBusinessPhases(
      updateCheckedOptions(selectedBusinessPhases, id, checked)
    );
  };

  useEffect(() => {}, [candidature, selectedBusinessPhases, selectedWorkAreas]);

  return (
    <FormGroup legendText="DADOS DO NEGÓCIO" className="section-header">
      {selectedBusinessPhases && (
        <fieldset className="bx--fieldset">
          <legend className="bx--label">
            14. Em que fase está o teu negócio?
          </legend>
          <p>
            Escolhe as opções que melhor descrevem o ponto em que está a tua
            ideia de negócio, projecto, marca ou empresa:
          </p>
          <Row>
            <Column sm={12} md={12} lg={12}>
              {businessPhases.map((x) => (
                <DynamicCheckbox
                  key={"bp" + x.id}
                  id={x.id}
                  disabled={disabled}
                  label={x.description}
                  updateItems={updatePhases}
                  checked={isCandidatureOptionChecked(
                    selectedBusinessPhases,
                    x.id
                  )}
                />
              ))}
            </Column>
          </Row>
        </fieldset>
      )}
      <fieldset className="bx--fieldset">
        <Row>
          <Column xml={12} sm={12} md={12} lg={12} className="required">
            <TextInput
              labelText="15. Qual é o nome do seu negócio?"
              id="businessName"
              maxLength={255}
              disabled={disabled}
              {...register("businessName")}
            />
            <p className="field-error">{errors.businessName?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xml={12} sm={6} md={4} lg={4} className="required">
            <GenericCombo
              id="legalFormCode"
              name="legalFormCode"
              label="16. Qual é a forma legal do seu negócio?"
              disabled={disabled}
              register={register}
              items={legalForms}
              // onChange={handleDocTypeChange}
            />
            <p className="field-error">{errors.legalFormCode?.message}</p>
          </Column>
          <Column xml={12} sm={6} md={4} lg={4} className="required">
            <RadioButtonGroup
              name="hasLicense"
              disabled={disabled}
              legendText="17. Possui alvará para o seu negócio?"
              valueSelected={candidature?.hasLicense?.toString()}
            >
              <RadioButton
                labelText="Sim"
                value="true"
                id="licence-y"
                {...register("hasLicense")}
              />
              <RadioButton
                labelText="Não"
                value="false"
                id="licence-n"
                {...register("hasLicense")}
              />
            </RadioButtonGroup>
            <p className="field-error">{errors.hasLicense?.message}</p>
          </Column>
          <Column xml={12} sm={6} md={4} lg={4} className="required">
            <RadioButtonGroup
              name="usesAccounting"
              disabled={disabled}
              legendText="18. Usa algum tipo de registo contabilístico na gestão do negócio?"
              valueSelected={candidature?.usesAccounting?.toString()}
            >
              <RadioButton
                labelText="Sim"
                value="true"
                id="accounting-y"
                {...register("usesAccounting")}
              />
              <RadioButton
                labelText="Não"
                value="false"
                id="accounting-n"
                {...register("usesAccounting")}
              />
            </RadioButtonGroup>
            <p className="field-error">{errors.usesAccounting?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xml={12} sm={6} md={4} lg={4} className="required">
            <GenericCombo
              id="businessManagerCode"
              name="businessManagerCode"
              label="19. Quem faz a gestão do negócio?"
              disabled={disabled}
              register={register}
              items={businessManagements}
              // onChange={handleDocTypeChange}
            />
            <p className="field-error">{errors.businessManagerCode?.message}</p>
          </Column>
          <Column xml={12} sm={6} md={4} lg={4} className="required">
            <TextInput
              labelText="20. Quantos trabalhadores possui?"
              id="totalWorkers"
              maxLength={12}
              disabled={disabled}
              {...register("totalWorkers")}
            />
            <p className="field-error">{errors.totalWorkers?.message}</p>
          </Column>
          <Column xml={12} sm={6} md={2} lg={2} className="required">
            <TextInput
              labelText="21.1 Mulheres"
              id="femaleWorkers"
              maxLength={12}
              disabled={disabled}
              {...register("femaleWorkers")}
            />
            <p className="field-error">{errors.femaleWorkers?.message}</p>
          </Column>
          <Column xml={12} sm={6} md={2} lg={2} className="required">
            <TextInput
              labelText="21.2 Homens"
              id="maleWorkers"
              maxLength={12}
              disabled={disabled}
              {...register("maleWorkers")}
            />
            <p className="field-error">{errors.maleWorkers?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xml={12} sm={6} md={6} lg={6}>
            <legend className="bx--label">
              22. Conforme a distribuição anterior, quantos têm idades entre 18
              a 35 anos?
            </legend>
            <Row>
              <Column xml={12} sm={12} md={6} lg={6} className="required">
                <TextInput
                  labelText="1.	Mulheres (18-35 anos) "
                  id="femaleWorkers18To35"
                  maxLength={12}
                  disabled={disabled}
                  {...register("femaleWorkers18To35")}
                />
                <p className="field-error">
                  {errors.femaleWorkers18To35?.message}
                </p>
              </Column>
              <Column xml={12} sm={12} md={6} lg={6} className="required">
                <TextInput
                  labelText="2.	Homens (18-35 anos)"
                  id="maleWorkers18To35"
                  maxLength={12}
                  disabled={disabled}
                  {...register("maleWorkers18To35")}
                />
                <p className="field-error">
                  {errors.maleWorkers18To35?.message}
                </p>
              </Column>
            </Row>
          </Column>
          <Column xml={12} sm={6} md={6} lg={6}>
            <legend className="bx--label">
              23.1 Qual é o nível de salário dos seus trabalhadores?
            </legend>
            <Row>
              <Column xml={12} sm={12} md={6} lg={6} className="required">
                <TextInput
                  labelText="Mínimo"
                  id="minSalary"
                  maxLength={12}
                  disabled={disabled}
                  {...register("minSalary")}
                />
                <p className="field-error">{errors.minSalary?.message}</p>
              </Column>
              <Column xml={12} sm={12} md={6} lg={6} className="required">
                <TextInput
                  labelText="Máximo"
                  id="maxSalary"
                  maxLength={12}
                  disabled={disabled}
                  {...register("maxSalary")}
                />
                <p className="field-error">{errors.maxSalary?.message}</p>
              </Column>
            </Row>
          </Column>
        </Row>
        <Row>
          <Column xml={12} sm={7} md={7} lg={7} className="required">
            <RadioButtonGroup
              name="salaryEvolution"
              disabled={disabled}
              legendText="23.2 Existe alguma perespectiva de evolução dos salários, caso seja beneficiária da subvenção?"
              valueSelected={candidature?.salaryEvolution?.toString()}
            >
              <RadioButton
                labelText="Sim"
                value="true"
                id="sal-evol-y"
                {...register("salaryEvolution")}
              />
              <RadioButton
                labelText="Não"
                value="false"
                id="sal-evol-n"
                {...register("salaryEvolution")}
              />
            </RadioButtonGroup>
            <p className="field-error">{errors.salaryEvolution?.message}</p>
          </Column>
          <Column xml={12} sm={6} md={5} lg={5}>
            <legend className="bx--label">
              23.3 Qual seria a perspectiva de evolução?
            </legend>
            <Row>
              <Column xml={12} sm={12} md={6} lg={6} className="required">
                <TextInput
                  labelText="Mínimo"
                  id="projectedMinSalary"
                  maxLength={12}
                  disabled={disabled}
                  {...register("projectedMinSalary")}
                />
                <p className="field-error">
                  {errors.projectedMinSalary?.message}
                </p>
              </Column>
              <Column xml={12} sm={12} md={6} lg={6} className="required">
                <TextInput
                  labelText="Máximo"
                  id="projectedMaxSalary"
                  maxLength={12}
                  disabled={disabled}
                  {...register("projectedMaxSalary")}
                />
                <p className="field-error">
                  {errors.projectedMaxSalary?.message}
                </p>
              </Column>
            </Row>
          </Column>
        </Row>
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="mainClients"
              labelText="24 Quem são os seus principais clientes?"
              rows={5}
              enableCounter
              disabled={disabled}
              helperText="[Use no máximo 100 palavras.]"
              {...register("mainClients")}
            />
            <p className="field-error">{errors.mainClients?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xml={12} sm={6} md={3} lg={3}>
            <TextInput
              labelText="25.1 Qual é a estimativa do número actual de clientes para o seu negócio?"
              id="estimatedCurrentClients"
              maxLength={12}
              disabled={disabled}
              {...register("estimatedCurrentClients")}
            />
            <p className="field-error">
              {errors.estimatedCurrentClients?.message}
            </p>
          </Column>
          <Column xml={12} sm={6} md={9} lg={9}>
            <legend className="bx--label">
              25.2 Qual é a projeção do crescimento dos seus clientes durante os
              próximos 3 anos?
            </legend>
            <Row>
              <Column xml={12} sm={12} md={4} lg={4} className="required">
                <TextInput
                  labelText="1º Ano"
                  id="projectedClientsYear1"
                  maxLength={12}
                  disabled={disabled}
                  {...register("projectedClientsYear1")}
                />
                <p className="field-error">
                  {errors.projectedClientsYear1?.message}
                </p>
              </Column>
              <Column xml={12} sm={12} md={4} lg={4} className="required">
                <TextInput
                  labelText="2º Ano"
                  id="projectedClientsYear2"
                  maxLength={12}
                  disabled={disabled}
                  {...register("projectedClientsYear2")}
                />
                <p className="field-error">
                  {errors.projectedClientsYear2?.message}
                </p>
              </Column>
              <Column xml={12} sm={12} md={4} lg={4} className="required">
                <TextInput
                  labelText="3º Ano"
                  id="projectedClientsYear3"
                  maxLength={12}
                  disabled={disabled}
                  {...register("projectedClientsYear3")}
                />
                <p className="field-error">
                  {errors.projectedClientsYear3?.message}
                </p>
              </Column>
            </Row>
          </Column>
        </Row>
      </fieldset>
      <Row>
        <Column xml={12} sm={12} md={6} lg={6}>
          {selectedWorkAreas && (
            <fieldset className="bx--fieldset">
              <legend className="bx--label">26. Em que área trabalhas?</legend>
              <p>Listar a(s) área(s):</p>

              <Row>
                <Column sm={12} md={12} lg={12}>
                  {workAreas.map((x) => (
                    <DynamicCheckbox
                      key={"wa" + x.id}
                      id={x.id}
                      disabled={disabled}
                      label={x.description}
                      updateItems={updateWorkAreas}
                      checked={isCandidatureOptionChecked(
                        selectedWorkAreas,
                        x.id
                      )}
                    />
                  ))}
                </Column>
              </Row>
            </fieldset>
          )}
        </Column>
        <Column xml={12} sm={12} md={6} lg={6}>
          <Row>
            <Column xml={12} sm={12} md={12} lg={12} className="required">
              <TextInput
                labelText="27. Qual foi o seu total de vendas no mês passado?"
                id="lastYearTotalSales"
                maxLength={12}
                disabled={disabled}
                {...register("lastYearTotalSales")}
              />
              <p className="field-error">
                {errors.lastYearTotalSales?.message}
              </p>
            </Column>
          </Row>
          <Row>
            <Column xml={12} sm={12} md={12} lg={12} className="required">
              <GenericCombo
                id="ecommercePlatformCode"
                name="ecommercePlatformCode"
                label="27.1 A sua empresa utiliza plataformas de comércio eletrónico para vendas ou encomendas de clientes?"
                disabled={disabled}
                register={register}
                items={ecommercePlatforms}
                // onChange={handleDocTypeChange}
              />
              <p className="field-error">
                {errors.ecommercePlatformCode?.message}
              </p>
            </Column>
          </Row>
          <Row>
            <Column xml={12} sm={12} md={12} lg={12}>
              <GenericCombo
                id="orderSourceCode"
                name="orderSourceCode"
                label="27.2 Se sim, de onde é que a sua empresa recebe a maior parte das encomendas?"
                disabled={disabled}
                register={register}
                items={orderSources}
                // onChange={handleDocTypeChange}
              />
              <p className="field-error">{errors.orderSourceCode?.message}</p>
            </Column>
          </Row>
          <Row>
            <Column xml={12} sm={12} md={12} lg={12} className="required">
              <RadioButtonGroup
                name="knowsPossibleEnvironmentalEffects"
                disabled={disabled}
                legendText="28 Conhece os possíveis efeitos ambientais causados pelo seu negócio?"
                valueSelected={candidature?.knowsPossibleEnvironmentalEffects?.toString()}
              >
                <RadioButton
                  labelText="Sim"
                  value="true"
                  id="env-effects-y"
                  {...register("knowsPossibleEnvironmentalEffects")}
                />
                <RadioButton
                  labelText="Não"
                  value="false"
                  id="env-effects-n"
                  {...register("knowsPossibleEnvironmentalEffects")}
                />
              </RadioButtonGroup>
              <p className="field-error">
                {errors.knowsPossibleEnvironmentalEffects?.message}
              </p>
            </Column>
          </Row>
          <Row>
            <Column xml={12} sm={12} md={12} lg={12}>
              <TextArea
                id="measuresToMinimizeEffects"
                labelText="29. Se sim, que medidas já colocou/ colocará em prática para minimizar tais efeitos?"
                rows={5}
                enableCounter
                disabled={disabled}
                helperText="[Use no máximo 100 palavras.]"
                {...register("measuresToMinimizeEffects")}
              />
              <p className="field-error">
                {errors.measuresToMinimizeEffects?.message}
              </p>
            </Column>
          </Row>
          <Row>
            <Column xml={12} sm={12} md={12} lg={12} className="required">
              <RadioButtonGroup
                name="knowsHealthAndSafetyAtWork"
                disabled={disabled}
                legendText="30. Conhece a importância/obrigação legal do uso das regras de Higeine e Segurança no Trababalho?"
                valueSelected={candidature?.knowsHealthAndSafetyAtWork?.toString()}
              >
                <RadioButton
                  labelText="Sim"
                  value="true"
                  id="safety-y"
                  {...register("knowsHealthAndSafetyAtWork")}
                />
                <RadioButton
                  labelText="Não"
                  value="false"
                  id="safety-n"
                  {...register("knowsHealthAndSafetyAtWork")}
                />
              </RadioButtonGroup>
              <p className="field-error">
                {errors.knowsHealthAndSafetyAtWork?.message}
              </p>
            </Column>
          </Row>
          <Row>
            <Column xml={12} sm={12} md={12} lg={12}>
              <RadioButtonGroup
                name="willPutIntoPractice"
                disabled={disabled}
                legendText="31. Se sim, colocará em prática no dia a dia do seu negócio?"
                valueSelected={candidature?.willPutIntoPractice?.toString()}
              >
                <RadioButton
                  labelText="Sim"
                  value="true"
                  id="practice-y"
                  {...register("willPutIntoPractice")}
                />
                <RadioButton
                  labelText="Não"
                  value="false"
                  id="practice-n"
                  {...register("willPutIntoPractice")}
                />
              </RadioButtonGroup>
            </Column>
          </Row>
        </Column>
      </Row>
    </FormGroup>
  );
};

BusinessDetailsForm.defaultProps = {
  disabled: false,
};

export default BusinessDetailsForm;
